import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import {
  CityNameFilterGroup,
  BrowseNameWrap,
  BrowseNameTitle,
  BrowseNameDash,
  BrowseButtonGroup,
  BrowseButton,
  BrowseStateCityTitle,
  CityNameFilterWrap,
  CityNameFilterTitle,
  CityNameFilterText,
  CityNameFilterButtonGroup,
  CityNameButton,


} from "./cityNameFilterStyle";
import { statesAbbriviation } from '../../../pages/categoryCause/stateData';
import { useParams } from 'react-router-dom';
type CityNameFilterProps = {
  showTitleBox?: boolean,
  page_range?: Array<number>
}
const CityNameFilter = ({ page_range, showTitleBox = true }: CityNameFilterProps) => {
  const { alpha } = useParams()


  return (
    <CityNameFilterGroup>

      {showTitleBox && <CityNameFilterWrap className="city-name-filter-wrap">
        <CityNameFilterTitle className="cityName-title">Find Nonprofits and Charities</CityNameFilterTitle>

        <CityNameFilterText className="cityName-text">Want to donate to or volunteer for a charity or nonprofit? See ratings and reviews. Find top-rated nonprofits and charities and start volunteering or donating today.</CityNameFilterText>

        <CityNameFilterButtonGroup>
          <CityNameButton href={"/navigation/state"}>Browse by State</CityNameButton>
          <CityNameButton href={"/navigation/issues"}>Browse by Category</CityNameButton>
        </CityNameFilterButtonGroup>

      </CityNameFilterWrap>}

      <BrowseStateCityTitle className="browse-state-title">
        Browse by State and City
      </BrowseStateCityTitle>

      <BrowseNameWrap className="browse-name-wrap">
        <BrowseNameTitle className="browse-name-title">Browse by Name</BrowseNameTitle>
        <BrowseNameDash className="browse-name-dash">-</BrowseNameDash>

        <BrowseButtonGroup className="browse-button-group">

          <BrowseButton className="browse-button-link" href="/nonprofits/0-9/1">0-9</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/A/1">A</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/B/1">B</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/C/1">C</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/D/1">D</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/E/1">E</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/F/1">F</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/G/1">G</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/H/1">H</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/I/1">I</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/J/1">J</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/K/1">K</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/L/1">L</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/M/1">M</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/N/1">N</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/O/1">O</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/P/1">P</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/Q/1">Q</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/R/1">R</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/S/1">S</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/T/1">T</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/U/1">U</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/V/1">V</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/W/1">W</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/X/1">X</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/Y/1">Y</BrowseButton>
          <BrowseButton className="browse-button-link" href="/nonprofits/Z/1">Z</BrowseButton>
        </BrowseButtonGroup>
      </BrowseNameWrap>

      {Array.isArray(page_range) && page_range.length > 1 && <BrowseNameWrap className="browse-name-wrap">
        <BrowseNameTitle className="browse-name-title">Browse by Page</BrowseNameTitle>
        <BrowseNameDash className="browse-name-dash">-</BrowseNameDash>

        <BrowseButtonGroup className="browse-button-group">
          {page_range.map(item => (
            <BrowseButton key={(alpha as string) + item} className="browse-button-link" href={`/nonprofits/${alpha}/${item}`}>{item}</BrowseButton>
          ))}
        </BrowseButtonGroup>
      </BrowseNameWrap>}

      <BrowseNameWrap className="browse-name-wrap">
        <BrowseButtonGroup className="browse-state-button-group">
          <BrowseNameTitle className="browse-name-title-black">Browse by State - </BrowseNameTitle>
          {statesAbbriviation?.map(item => <BrowseButton key={item.name} className="browse-button-link-blk" href={item.href}>{item.name}</BrowseButton>)}
        </BrowseButtonGroup>
      </BrowseNameWrap>

    </CityNameFilterGroup>
  );
}

export default CityNameFilter;
